<template>
  <div class="text-center">
    <!--<b-spinner style="width: 6rem; height: 6rem;" variant="info" label="Spinning"></b-spinner>-->
    <img
      src="https://admisionlogos.s3.amazonaws.com/postulacion-validacion-comprobante-vue/cargador-logo-sistema-de-admision.png"
      class="img-fluid d-block mt-1 mb-2 mt-lg-2 mx-auto"
      alt
    />
  </div>
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// src/components/generales/modales/Cargando.vue